import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import en from "./locales/en.json";
import pt from "./locales/pt.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import zh from "./locales/zh.json";

/**
 * Supported languages configuration
 */
export const SUPPORTED_LANGUAGES = {
  en: { name: "English", flag: "🇺🇸" },
  pt: { name: "Português", flag: "🇧🇷" },
  es: { name: "Español", flag: "🇪🇸" },
  fr: { name: "Français", flag: "🇫🇷" },
  zh: { name: "中文", flag: "🇨🇳" },
};

/**
 * Default language fallback
 */
export const DEFAULT_LANGUAGE = "en";

/**
 * Available language codes
 */
export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES);

/**
 * Initialize i18next configuration
 */
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Resources
    resources: {
      en: { translation: en },
      pt: { translation: pt },
      es: { translation: es },
      fr: { translation: fr },
      zh: { translation: zh },
    },

    // Language detection options
    detection: {
      // Detection order
      order: ["localStorage", "navigator", "htmlTag"],
      // Cache user language
      caches: ["localStorage"],
      // Check for navigator language
      checkWhitelist: true,
    },

    // Fallback language
    fallbackLng: DEFAULT_LANGUAGE,

    // Debug mode (disable in production)
    debug: import.meta.env.DEV,

    // Key separator (disable for nested keys like "common.loading")
    keySeparator: ".",

    // Namespace separator
    nsSeparator: ":",

    // Interpolation options
    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // React options
    react: {
      useSuspense: false, // Disable suspense mode for better error handling
    },
  });

export default i18n;
